<template>
    <div class="page no-top-bar have-menu">
        <div>
            <TopBarDetail
                :title="lbl.helpchat.title"
                :isShowBack="true"
                :isShowFavorite="false"
                :isShowShare="false"
                @clickBack="clickBack()"
            ></TopBarDetail>
            <div class="bg-comment my-4 mx-4 p-3 border border-a-gray-666666 rounded-2xl"
                v-for="(comment) in commentList"
                :key="comment.id">
                <div class="flex items-center pb-2.5 mb-2.5 border-b border-a-gray-c6c6c6">
                    <img class="h-3.5 w-auto" src="@/assets/icon/ic-time.png" alt=""/>
                    <div class="ml-2 text-14 text-a-gray-666666">{{ getDateTimeformat(comment.createdTime) }}</div>
                </div>
                <div v-if="comment.imageUrl">
                    <img :src="comment.imageUrl" alt=""/>
                </div>
                <div class="text-20 text-a-gray-666666">
                    {{ comment.message }}
                </div>
            </div>
            <div>
                <AddComment
                    ref="helpchat-addcomment"
                    :modalController="modalController"
                    @saveCommentSuccess="saveCommentSuccess($event)">
                </AddComment>
            </div>
        </div>

        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>

import AddComment from "../component/AddComment.vue";
import BzbsHelpchat from "@/core/Helpchat/BzbsHelpchat.js";
import TopBarDetail from "@/components/Layout/TopBar/TopBarDetail.vue";
//helper
import DatetimeHelper from "@/helper/DatetimeHelper.js"
import { CampaignListConfigBuilder } from "@/core/Campaign/config/CampaignConfigModel.js";
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ModalMixin from "@/mixin/ModalMixin.js";

export default({
    name: "helpchatDetail",
    mixins: [LocaleMixin, ModalMixin],
    components: {
        AddComment,
        TopBarDetail,
    },
    data: function() {
        return {
            buzzKey: "",
            commentList: [],
            listConfig: null,
            isLoading: false,
            isLoaded: false,
            isHaveItem: false,
            strLastRowKey: "",
        }
    },
    created: function() {
        this.setScrollLoadMore();
        this.initialConfig();
    },
    mounted: function() {
        this.buzzKey = this.$route.params.id;
        this.getComment();
    },
    methods: {
        initialConfig: function() {
            let listConfig = new CampaignListConfigBuilder()
                .setTop(10)
                .create();
            this.listConfig = listConfig;
            console.log("listConfig", this.listConfig);
        },
        setScrollLoadMore: function() {
            window.onscroll = () => {
                // 100 คือระยะก่อนถึงจุดล่างสุดของ page
                let scrollOffSet = 100;
                let pageHeight = Math.max(
                    window.scrollY,
                    document.documentElement.scrollTop,
                    document.body.scrollTop
                );
                let bottomOfWindow =
                    pageHeight + window.innerHeight >
                    document.documentElement.offsetHeight - scrollOffSet;
                if (bottomOfWindow && pageHeight > 10) {
                    this.loadMore();
                }
            };
        },
        loadMore: function () {
            if (!this.listConfig.isSeeMoreEnable || this.isLoading) {
                return;
            }
            this.getComment();
        },
        getComment: function () {

            this.strLastRowKey = "";
            if (this.commentList.length > 0) {
                this.strLastRowKey = this.commentList[this.commentList.length-1].rowKey;
            }
            this.isLoading = true;
            BzbsHelpchat.apiGetAllcomment(this.buzzKey, this.listConfig.defaultTopAmount, this.strLastRowKey).subscribe({
                next: (comments) => {
                    console.log(comments);

                    this.listConfig.intSkip += this.listConfig.defaultTopAmount;

                    if (comments && comments.length < this.listConfig.defaultTopAmount) {
                        this.listConfig.isSeeMoreEnable = false;
                    }

                    if (this.listConfig.intSkip == this.listConfig.defaultTopAmount) {
                        this.commentList = [];
                    }
                    for (let data of comments) {
                        //TODO: Add GA Tracking.
                        this.commentList.push(data);
                    }
                    this.isLoading = false;
                    this.isLoaded = true;
                    this.isHaveItem = this.commentList.length > 0
                        ? true
                        : false;
                },
                error: (err) => {
                    this.isLoading = false;
                    this.isLoaded = true;
                    this.isHaveItem = false;
                    console.log(err);
                    console.log(err);
                }
            });
        },
        reloadComment: function () {
            this.strLastRowKey = "";
            this.commentList = [];
            this.getComment();
        },
        saveCommentSuccess: function (dataSave) {
            this.loadingModal.show();
            return new Promise((resolve) => {
                BzbsHelpchat.apiReplycomment(dataSave.content, "source", dataSave.objUpload, this.buzzKey).subscribe({
                    next: (data) => {
                        this.loadingModal.hide();
                        console.log(data);
                        this.$refs['helpchat-addcomment'].removeImage();
                        this.$refs['helpchat-addcomment'].content = "";
                        this.reloadComment();
                        resolve(true);
                    },
                    error: (err) => {
                        this.loadingModal.hide();
                        this.alertModal
                            .clearModal()
                            .setMsg(err.message)
                            .show()
                        console.log(err);
                        resolve(false);
                    }
                });
            });
        },
        clickBack: function () {
            this.$router.back();
        },
        getDateTimeformat: function (date) {
            return DatetimeHelper.getDatetimeFullFormatNoti(date);
        },
    }
})
</script>
<style lang="scss" scoped>
    .bg-comment {
        background-color: rgba(255, 255, 255, 0.4);
    }
</style>
